import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** Right-aligned slot holding a row's service metadata boxes. */
const RowDetailsContainer = ({ sx, ...rest }: BoxProps) => (
	<Box
		sx={combineSx(
			{
				display: 'flex',
				gap: 300,
				alignItems: 'center',
				justifyContent: 'flex-end',
				flex: '1 1 0',
				minWidth: 0,
			},
			sx,
		)}
		{...rest}
	/>
);

export default RowDetailsContainer;
